<template>
  <div>
    <top-bar/>
    <div class="content pt-4">
      <div class="container-fluid">
        <relatorios/>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/commons/TopBar";
import Relatorios from "@/views/comanda/Relatorios";

export default {
  name: 'RelatorioComandas',
  components: {Relatorios, TopBar}
}
</script>
